import { dateFormat } from '@mirai/locale';

import { parseCustomData, sendData } from './helpers';
import { getOccupationTotals } from '../../../../components/helpers';
import { fetchUrlParams } from '../../../../helpers';
import { getRoomsPriceRange } from '../helpers';
import { formatPrice } from '../helpers/legacy';

export const ratesResponse = async ({
  instances = [],
  metaEventId,
  response: {
    finder: { calendar = [], occupation = [], place: { id: [placeHotelId] = [], isHotel } = {} } = {},
    infantAge,
    tracking = {},
  } = {},
  store: { hotel = {} } = {},
} = {}) => {
  // ! -- TODO: Try to get all data from store -------------------------------------------------------------------------
  const { idchain } = fetchUrlParams(location.search);

  // ! -- TODO: use of tracking should be a temporary approach ---------------------------------------------------------
  const {
    country,
    hotelInfo: {
      currency: hotelCurrency = {},
      hotelCity: city,
      hotelCountry = country,
      hotelProvince: region,
      propertyName,
    } = {},
    hotelInfoBAR = [],
    rates = {},
  } = tracking;

  let contents = [];
  let numItems = 0;
  Object.entries(getRoomsPriceRange(rates, hotelCurrency)).forEach(([key, { minRate = {}, maxRate = {} } = {}]) => {
    const quantity = rates[key].amountAvailable;

    contents = [
      ...contents,
      {
        id: minRate.id,
        quantity,
        itemPrice: formatPrice(minRate.totalPriceWithTaxes, hotelCurrency),
      },
      {
        id: maxRate.id,
        quantity,
        itemPrice: formatPrice(maxRate.totalPriceWithTaxes, hotelCurrency),
      },
    ];

    numItems += 2 * quantity;
  });

  const hotelId = isHotel ? placeHotelId : hotel.id;
  const hasHotelRates = Object.keys(rates).length > 0;
  const contentIds = hasHotelRates
    ? [hotelId].filter(Boolean)
    : hotelInfoBAR.length
    ? hotelInfoBAR.map(({ idTokenProvider }) => idTokenProvider).filter(Boolean)
    : [hotelId].filter(Boolean);
  const miraiRates = contents.map(({ id }) => id);
  const { adults = 0, babies = 0, children = 0 } = getOccupationTotals({ infantAge, occupation });
  const hasDates = calendar.length === 2;
  const commonData = {
    customData: parseCustomData({
      contentIds,
      contents: contentIds.length === 1 ? contents : [],
      country: hotelCountry,
      ...(hasDates
        ? {
            checkinDate: dateFormat(calendar[0], { delimiter: '-', format: 'YYYY-MM-DD' }),
            checkoutDate: dateFormat(calendar[1], { delimiter: '-', format: 'YYYY-MM-DD' }),
          }
        : undefined),
      city,
      hotelCurrency,
      miraiRates,
      numItems,
      numAdults: adults,
      numChildren: babies + children,
      propertyName,
      region,
    }),
  };

  const events = [
    'Search',
    ...(contentIds.length === 1 && hasHotelRates ? ['ViewContent'] : []),
    ...(idchain && contentIds.length === 1 ? [`Search_${contentIds[0]}`] : []),
  ];

  const responses = await Promise.all(
    events.flatMap((eventName) =>
      instances.map(({ idTracking, pixelId }) =>
        sendData({ ...commonData, eventId: metaEventId, eventName, idTracking, pixelId }),
      ),
    ),
  ).catch(() => {});

  return responses;
};
